// extracted by mini-css-extract-plugin
export default {"bookingSelection":"chooseBookingType_bookingSelection__W7gun","bookingSkeleton":"chooseBookingType_bookingSkeleton__BBB8z"};